import { useCallback } from 'react'
import { handleAxiosError, useToast } from '~/shared/lib'

export const useErrorHandler = () => {
  const toast = useToast()

  const handleErrorWithToast = useCallback(
    (error: unknown, defaultMessage = 'Произошла ошибка'): string => {
      const errorMessage = handleAxiosError(error) || defaultMessage
      toast.open(errorMessage, 'danger')
      return errorMessage
    },
    [toast],
  )

  return { handleErrorWithToast }
}
